import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Rules from "./pages/Rules";
import Teams from "./pages/Teams";
import Standings from "./pages/Standings";
import Bracket from "./pages/Bracket";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <Navbar />
        <main className="min-h-[calc(100vh-180px)]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/rules/:slug" element={<Rules />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/standings" element={<Standings />} />
            <Route path="/bracket" element={<Bracket />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#150A26",
              border: "1px solid rgba(157, 76, 221, 0.4)",
              color: "#fff",
              fontFamily: "Exo 2, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
